import round from 'lodash/round';
import isNumber from 'lodash/isNumber';

import {commaizeNumber} from 'common/util';
import {formatConciseDuration, formatTime} from 'common/util/date';
import {TooltipItemType} from 'common/components/chart-tooltip/types';
import {getBucketData, sumSingleBucketData} from 'common/report/funnels/models/bar-chart/utils';
import {PercentileKey, TextLabelFormatter, TimeBucketKey} from 'common/report/funnels/models/bar-chart/types';
import {FunnelStep} from 'common/report/funnels/models/types';

export function getBucketAccessor(stepIndex: number | null) {
  return stepIndex === null ? TimeBucketKey.START : TimeBucketKey.PREV;
}

export function getMedianAccessor(stepIndex: number | null) {
  return stepIndex === null ? PercentileKey.START : PercentileKey.PREV;
}

export function getFormattedUserPct(funnelStep: FunnelStep, bucketAccessor: keyof FunnelStep) {
  const bucketData = getBucketData(funnelStep, bucketAccessor);
  return funnelStep.count ? round((sumSingleBucketData(bucketData) / funnelStep.count) * 100, 1) : 0;
}

export function getTTCShiftedEventIndex(eventIndex: number | null) {
  return isNumber(eventIndex) ? eventIndex + 1 : null;
}

export function getMedianToolTipText(median: string) {
  return [
    {
      items: [
        {text: median, type: TooltipItemType.Data},
        {text: `median time to convert`, type: TooltipItemType.Text},
      ],
    },
  ];
}

export function getToolTipText(count: number, percentage: number, bucketLabel: string) {
  return [
    {
      items: [
        {text: `${percentage}%`, type: TooltipItemType.Data},
        {text: `of conversions between`, type: TooltipItemType.Text},
        {text: bucketLabel, type: TooltipItemType.Data},
      ],
    },
    {
      items: [
        {text: commaizeNumber(count), type: TooltipItemType.Data},
        {text: `conversions`, type: TooltipItemType.Text},
      ],
    },
  ];
}

export function getMedianFormatter(median: number) {
  return `${isNumber(median) ? formatConciseDuration(median) : `N/A`}`;
}

export function getBucketLabel(bucketStart: number, bucketEnd?: number, precision?: number) {
  return bucketEnd ? formatTime(bucketStart, bucketEnd, precision) : formatTime(bucketStart, bucketStart);
}

export const labelFormatter: TextLabelFormatter = {
  getBucketLabel,
  getMedianFormatter,
  getToolTipText,
  getMedianToolTipText,
};
